// const debug = "ModuleProto"

import {featureAccess, featureRequiredLicenseType} from "../gd/access-control/feature-access/feature-access";
import {LicenseType} from "../gd/license/license-proto";
import {SettingsParentSection} from "../../app/settings/const";
import {Feature} from "../gd/access-control/feature-access/const";
import {SettingsSection, SettingsSectionTitleDict} from "../../app/settings/@const";

const debug = false

export type SettingsModuleConfig = {
    settingsUrl                 : string
    name                        : string
    description                 : string
    svgIcon                     : string
    keywords?                   : string
    settingsMenuTopCategory?    : SettingsMenuTopCategory
    typeLabel?                  : string
    feature?                    : string
    settingsSection?                    : SettingsSection
}

export enum SettingsMenuTopCategory {
    ORGANIZATION    = 'organization',
    MY_ACCOUNT      = 'my-account',
    INTEGRATIONS    = 'integrations'
}

export default class SettingsModule {

    public parentSection?           : SettingsParentSection     // used to generate breadcrumbs
    public settingsSection?           : SettingsSection     // used to generate breadcrumbs

    public settingsUrl              : string        = 'no-url-set'

    public name                     : string        = 'Unknown Module'
    public description              : string        = 'Unknown Module description'
    public svgIcon                  : string        = ''    // svg-icon class
    public keywords?                : string
    public typeLabel?               : string

    public canAccess                : boolean       = true      // if false current user has no access to this module settings = do not show in search results
    public settingsMenuTopCategory  : SettingsMenuTopCategory

    public feature?                 : Feature
    public requiredLicense?         : LicenseType

    // this 2 vars are needed for module settings interface
    _isEnabled                      : boolean       = true
    canDisable                      : boolean       = false
    hasStatus                       : boolean       = true  // if false hise enabled / disabled
    isComingSoon                    : boolean       = false
    _isAccessibleByLicense          : boolean       = true

    constructor(config?:SettingsModuleConfig) {

        if (config) {
            this.name           = config.name
            this.description    = config.description
            this.settingsUrl    = config.settingsUrl
            this.svgIcon        = config.svgIcon
            this.keywords       = config.keywords
            this.typeLabel      = config.typeLabel
            this.settingsSection = config.settingsSection

            // Patch typeLabel
            if (!this.typeLabel && this.settingsSection) {
                this.typeLabel = SettingsSectionTitleDict[this.settingsSection]
            }

        }



        // Set default access
        this.canAccess          = gd.ac.company.isManager()

        this.settingsMenuTopCategory    = _.get(config, 'settingsMenuTopCategory', SettingsMenuTopCategory.ORGANIZATION)

        this.feature                    = _.get(config, 'feature', undefined) as Feature
        this.validateFeature()
    }

    protected validateFeature() {
        // access and license
        if (this.feature) {
            this._isAccessibleByLicense = featureAccess(this.feature)

            if (!this._isAccessibleByLicense) {
                this.requiredLicense    = featureRequiredLicenseType(this.feature)
            }
        }
    }

    public search(keyword: string, searchByName:boolean, searchByDescription:boolean, searchByKeywords:boolean): boolean {

        // implement search ....

        // if (!this.canAccess) return false

        let found = false;

        if(searchByName) {
            found = found || this.name.trim().toLowerCase().includes(keyword.trim().toLowerCase())
        }

        if(searchByDescription) {
            found = found || this.description.trim().toLowerCase().includes(keyword.trim().toLowerCase())
        }

        if(searchByKeywords) {
            found = found || (this.keywords ? this.keywords?.trim().toLowerCase().includes(keyword.trim().toLowerCase()) : false);
        }

        // return this ?

        return found ? true : false
    }

    get enabled() {
        return this._isEnabled && this._isAccessibleByLicense
    }

    public goToSettings() {
        gd.navigation.goTo(this.settingsUrl)
    }

    disable() {
        console.warn("this module cannot be disabled")
    }

    enable() {
        console.warn("this module cannot be enabled")
    }

}
